import React, { useMemo, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { hostUrl } from './config';

const useQuery = () => {
  const { search } = useLocation();
  return useMemo(() => new URLSearchParams(search), [search]);
};

const ResetPassword = () => {
  const query = useQuery();
  const navigate = useNavigate();

  const [uid, setUid] = useState(query.get('uid') || '');
  const [token, setToken] = useState(query.get('token') || '');
  const [newPassword, setNewPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');
    setError('');

    try {
      const response = await axios.post(`${hostUrl}/password-reset-confirm/`, {
        uid,
        token,
        new_password: newPassword,
      });
      setMessage(response.data?.detail || 'Password reset successfully.');
      setTimeout(() => navigate('/login'), 1500);
    } catch (err) {
      const errorMsg = err.response?.data?.detail || err.response?.data?.new_password?.join?.(', ') || err.message || 'Failed to reset password.';
      setError(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="col-md-12">
      <div className="card card-container">
        <h4 className="mb-3">Set New Password</h4>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="uid">UID</label>
            <input
              type="text"
              className="form-control"
              name="uid"
              value={uid}
              onChange={(e) => setUid(e.target.value)}
              required
            />
          </div>
          <div className="form-group mt-3">
            <label htmlFor="token">Token</label>
            <input
              type="text"
              className="form-control"
              name="token"
              value={token}
              onChange={(e) => setToken(e.target.value)}
              required
            />
          </div>
          <div className="form-group mt-3">
            <label htmlFor="new_password">New Password</label>
            <input
              type="password"
              className="form-control"
              name="new_password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
            />
          </div>

          <div className="form-group mt-3">
            <button className="btn btn-primary btn-block" disabled={loading}>
              {loading && <span className="spinner-border spinner-border-sm me-2"></span>}
              <span>Reset Password</span>
            </button>
          </div>

          {message && (
            <div className="form-group mt-3">
              <div className="alert alert-success" role="alert">
                {message}
              </div>
            </div>
          )}

          {error && (
            <div className="form-group mt-3">
              <div className="alert alert-danger" role="alert">
                {error}
              </div>
            </div>
          )}
        </form>

        <div className="mt-3">
          <Link to="/login">Back to login</Link>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
